import styled from '@emotion/styled';
import {
  spacing,
  mediaMin,
  mediaMax,
  borderRadius,
} from 'presentations/views/styles';
import { white } from 'presentations/views/styles/color';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  noVerticalPadding?: boolean;
  className?: string;
}

const Component = (props: Props) => (
  <Box className={props.className} noVerticalPadding={props.noVerticalPadding}>
    {props.children}
  </Box>
);

const Box = styled.div<{ noVerticalPadding?: boolean }>`
  background-color: ${white};
  margin: 0 auto ${spacing(40)};
  padding: ${({ noVerticalPadding }) => (noVerticalPadding ? '0' : spacing(24))}
    ${spacing(24)};
  border-radius: ${borderRadius(16)};
  ${mediaMin.tablet} {
    padding: ${({ noVerticalPadding }) =>
        noVerticalPadding ? '0' : spacing(48)}
      ${spacing(48)};
  }
  ${mediaMax.tablet} {
    padding: ${({ noVerticalPadding }) =>
        noVerticalPadding ? '0' : spacing(24)}
      ${spacing(20)};
  }
`;
export default Component;
